/* YouTube API - Controlling multiple video's */
/* ----------------------------------------------- */
var videoHeight= 420;
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var players = new Array();

function onYouTubeIframeAPIReady() {
    if (typeof videoPlayer === 'undefined') return;
    for (var i = 0; i < videoPlayer.length; i++) {
        var curplayer = createPlayer(videoPlayer[i]);
        players[i] = curplayer;
    }
}

function createPlayer(playerInfo){
    new YT.Player(playerInfo.id, {
        videoId: playerInfo.videoId,
        height: videoHeight,
        width: '100%',
        host: 'https://www.youtube-nocookie.com',
        playerVars: { 'autoplay': playerInfo.autoplay, 'controls': 0, 'rel': 0, 'fs': 1, 'showinfo': 0, 'mute': playerInfo.mute },
        events: {
            'onStateChange': function(event){
                var $video =  $("." + playerInfo.id);
                if (event.data == YT.PlayerState.PLAYING) {
                    $video.addClass('video-playing');
                }
                if (event.data == YT.PlayerState.ENDED) {
                    $video.removeClass('video-playing video-loading');
                }
            },
            'onReady': function(event){
                $('.overlay').click(function() {
                    var id = $(this).attr('data-attribute');
                    var $video = $("." + id);

                    if(id === playerInfo.id) {
                        if($video.hasClass('video-playing')) {
                            $video.removeClass('video-playing video-loading');
                            event.target.pauseVideo();
                        } else {
                            if(!$video.hasClass('video-loading')) {
                                $video.addClass('video-loading');
                                event.target.playVideo();
                            }
                        }
                    }
                });
            }
        }
    });
}
